import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FieldUserBrief from '../FieldUserBrief';
import { updateDirections } from '../../utilities';
import Availability from './Availability';
import Intakes from './Intakes';

export default function SelectedFieldUser({ inspector }) {
  // 1. Select Map
  const map = useSelector(state => state.mapping?.map);
  
  // 2. Select ONLY the project (the "Origin" of the route)
  // This replaces 'fullState'
  const originProject = useSelector(state => state.project);

  const [directionsLibraries, setDirectionsLibraries] = useState({});
  const [selectedProject, setSelectedProject] = useState({});

  // Map initialization effect
  useEffect(function () {
    if (!window.google || !map) return;

    const directionsService = new window.google.maps.DirectionsService();
    const directionsRenderer = new window.google.maps.DirectionsRenderer();
    
    directionsRenderer.setMap(map);

    setDirectionsLibraries({ directionsService, directionsRenderer });
  }, [map]);

  // Directions update effect
  useEffect(
    () => {
      // We pass 'originProject' instead of 'state'
      return updateDirections(selectedProject, originProject, directionsLibraries);
    },
    // Safe to include originProject now. 
    // It will only re-calculate if the main project being scheduled changes.
    [selectedProject, directionsLibraries, originProject] 
  );

  return (
    <div className="flex-column align-start">
      <FieldUserBrief inspector={inspector} />
      <Availability />
      <Intakes {...{ directionsLibraries, setSelectedProject, selectedProject }} />
    </div>
  );
}